import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-6 font-heading">Página não encontrada</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">Esta página ainda não foi criada. Volte para o início para explorar nosso conteúdo.</p>
        <a
          href="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          ← Voltar ao Início
        </a>
      </div>
    </div>
  );
}